<template>
    <div class="w-full h-full relative text-gray-300 dark:text-gray-600">
        <textarea :id="`textarea-${label}`" name="story" v-model="value" maxlength="255"
        @input="$emit('update:modelValue', $event.target.value)"
        @focus="onFocus = true" @blur="onFocus = false"
        class="w-full h-full block bg-transparent shadow-sm pl-2
        border border-gray-300 dark:border-gray-600 focus:border-transparent rounded-md
        focus:ring-indigo-500 focus:ring-2
        focus:text-gray-500 py-2 max-h-36 overflow-y-scroll
        transition-all duration-300 resize-none"></textarea>

        <!-- Label -->
        <label @click="giveFocus()"
        :class="onFocus ? 'text-indigo-500 -top-3 bg-gray-50 dark:bg-gray-900 px-1 text-sm' : value !== '' ? '-top-3 bg-gray-50 dark:bg-gray-900 px-1 text-sm text-gray-400 dark:text-gray-500' : ''"
        class="absolute ml-2 top-2 transition-all duration-300 select-none cursor-text">{{label}}</label>

    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'
export default {
    name: 'TextArea',
    props: ['modelValue', 'label', 'validation'],
    setup(props) {
        const onFocus = ref(false) 
        const showPassword = ref(false)
        const value = props.modelValue

        const label = computed(() => {
            return props.label
        })
        // Functions
        const giveFocus = (() => {
        document.getElementById(`textarea-${label.value}`).focus()
        })
        return {
            onFocus,
            value,
            label,
            giveFocus
        }
    }
}
</script>

<style>

</style>